module.exports = __webpack_public_path__ + "img/audio.4d3a9994.png";